import React, { useState, useEffect } from "react";
import Col from "react-bootstrap/esm/Col";
import { useDrop } from "react-dnd";

export default function Goal(props) {
  const [{ isOver }, goal] = useDrop(() => ({
    accept: "letter",
    drop: (item) => addLetter(item.name),
    collect: (monitor) => ({
      isOver: !!monitor.isOver(),
    }),
  }));

  const [draggedWord, setDraggedWord] = useState();
  const [incorrectValue, setIncorrectValue] = useState(false);
  const word = props.word.split("");

  const addLetter = (name) => {
    console.log(name);
    setDraggedWord(name);
    const newGuess = props.guess;
    newGuess[props.x] = name;
    const newAnsweredGuess = props.guess.toString().replaceAll(",", "");
    props.setGuessedAnswer(newAnsweredGuess);
    props.setAttempts((a) => a + 1);
    props.setGuess(newGuess);
    if (word[props.x] === name) {
      setIncorrectValue(false);
    } else {
      setIncorrectValue(true);
    }
  };

  useEffect(() => {
    if (props.hint === true) {
      if (incorrectValue === true || draggedWord === undefined) {
        if (word[props.x] === props.passHint) {
          setDraggedWord(props.passHint);
          const newGuess = props.guess;
          newGuess[props.x] = props.passHint;
          const newAnsweredGuess = props.guess.toString();
          props.setGuessedAnswer(newAnsweredGuess.replaceAll(",", ""));
          props.setAttempts((a) => a + 1);
          props.setGuess(newGuess);
          if (word[props.x] === props.passHint) {
            setIncorrectValue(false);
          } else {
            setIncorrectValue(true);
          }
          props.setHintToggle(false);
        } else {
          if (props.passHint === undefined && props.x === 0) {
            setDraggedWord(word[0]);
            const newGuess = props.guess;
            newGuess[props.x] = word[0];
            const newAnsweredGuess = props.guess.toString();
            props.setGuessedAnswer(newAnsweredGuess.replaceAll(",", " "));
            props.setAttempts((a) => a + 1);
            props.setGuess(newGuess);
            props.setHintToggle(false);
          }
        }
      }
    } else {
    }
  }, [props.hint]);

  const noErrorChecking = (
    <div
      ref={goal}
      key={props.letter.id}
      style={{
        border: isOver ? "solid 2px green" : "solid 2px #333",
        height: "80px",
        fontSize: "20px",
        boxShadow: !draggedWord && "inset #0000006e 0px 0px 7px 3px",
        borderRadius: "15px",
        width: "55px",
        padding: "1px",
        marginLeft: "auto",
        marginRight: "auto",
        backgroundColor: draggedWord && "rgb(10 205 240)",
        color: "white",
      }}
      value={props.x}
    >
      {draggedWord}
    </div>
  );
  const errorCheckingChange = (
    <div
      ref={goal}
      key={props.letter.id}
      style={{
        height: "80px",
        fontSize: "32px",
        boxShadow: !draggedWord && "inset #0000006e 0px 0px 7px 3px",
        borderRadius: "15px",
        width: "55px",
        border: isOver
          ? "solid 2px green"
          : incorrectValue
          ? "solid 2px red"
          : "solid 2px #333",
        marginLeft: "auto",
        marginRight: "auto",
        paddingTop: "10px",
        backgroundColor: draggedWord && "rgb(10 205 240)",
        color: "white",
      }}
      value={props.x}
    >
      {draggedWord}
    </div>
  );

  return (
    <>
      {!props.errorChecking && noErrorChecking}
      {props.errorChecking && errorCheckingChange}
    </>
  );
}
